import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldTypes,
  FieldWrapper,
  FlexRadioGroup,
  FormFieldsContainer,
  Label,
  MaskTextInput,
  RegularField,
  useFormContext,
} from '@common-fe/common-fe';

import masks from '@/common/masks';
import { EMPLOYER_ID_OPTIONS, EmployerIdType } from '@/modules/ExpressSetup/ExpressSetupSignUp/expressSetupSignUp.constants';
import { CreateOrganizationField, CreateOrganizationForm } from '@/modules/ExpressSetup/ExpressSetupSignUp/hooks/useCreateOrganizationForm';

const OrganizationProperties = () => {
  const { control, formState: { errors }, watch } = useFormContext<CreateOrganizationForm>();
  const employerIdType = watch(CreateOrganizationField.employerIdType);

  return (
    <Box
      pad={{ vertical: 'spacing24', horizontal: 'spacing32' }}
      background="canvas"
      round="container1Round"
    >
      <FormFieldsContainer margin={{ top: 'spacing16' }}>
        <FieldWrapper>
          <Label name={CreateOrganizationField.legalName} size="large" showRequireIcon>
            Legal name
          </Label>

          <ControllerWrapper errorText={errors?.[CreateOrganizationField.legalName]?.message} defaultSize>
            <Controller
              name={CreateOrganizationField.legalName}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="legal-name"
                  name={CreateOrganizationField.legalName}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Legal name"
                  isError={!!errors?.[CreateOrganizationField.legalName]?.message}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateOrganizationField.displayName} size="large" showRequireIcon>
            Display name
          </Label>

          <ControllerWrapper errorText={errors?.[CreateOrganizationField.displayName]?.message} defaultSize>
            <Controller
              name={CreateOrganizationField.displayName}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="display-name"
                  name={CreateOrganizationField.displayName}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Display name"
                  isError={!!errors?.[CreateOrganizationField.displayName]?.message}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper align="start">
          <Label name={CreateOrganizationField.employerId} size="large" showRequireIcon>
            Employer ID
          </Label>

          <Box>
            <ControllerWrapper errorText={errors?.[CreateOrganizationField.employerIdType]?.message} defaultSize>
              <Controller
                name={CreateOrganizationField.employerIdType}
                control={control}
                render={({ field }) => (
                  <FlexRadioGroup
                    type={FieldTypes.Radio}
                    name={CreateOrganizationField.employerIdType}
                    value={field.value}
                    onChange={field.onChange}
                    options={EMPLOYER_ID_OPTIONS}
                  />
                )}
              />
            </ControllerWrapper>
            
            {employerIdType === EmployerIdType.CUSTOM && (
              <Box margin={{ top: 'spacing16' }}>
                <ControllerWrapper errorText={errors?.[CreateOrganizationField.employerId]?.message} defaultSize>
                  <Controller
                    name={CreateOrganizationField.employerId}
                    control={control}
                    render={({ field }) => (
                      <RegularField
                        name={CreateOrganizationField.employerId}
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Enter Employer ID"
                        isError={!!errors?.[CreateOrganizationField.employerId]?.message}
                        isLarge
                        editMode
                      />
                    )}
                  />
                </ControllerWrapper>
              </Box>
            )}
          </Box>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateOrganizationField.taxId} size="large" showRequireIcon>
            Tax ID
          </Label>

          <ControllerWrapper defaultSize>
            <Controller
              name={CreateOrganizationField.taxId}
              control={control}
              render={({ field }) => (
                <MaskTextInput
                  testId="tax-id"
                  name={CreateOrganizationField.taxId}
                  errorText={errors?.[CreateOrganizationField.taxId]?.message}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Tax ID"
                  mask={masks.TAX_ID}
                  isLarge
                />
              )}
            />
          </ControllerWrapper>
          
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default OrganizationProperties;
